import { FormattedMessage } from "react-intl";
import { useOutletContext } from "react-router-dom";

import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import GetComponentsFromBloks from "../../helpers/bloksRenderer";

import styles from "./home.module.scss";
import HelmetSEO from "../../components/helmetSeo/helmetSeo";
import PageContentWrapper from "../../components/PageContentWrapper";
import { GetWindowLanguage } from "../../helpers/storyHelpers";

function HomeLayout() {
  const { story } = useOutletContext();

  let componentList = [];

  if (story && story.content && story.content.body) {
    componentList = GetComponentsFromBloks(story.content.body, story);
  }

  function handleScrollToTop() {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }

  return (
    <>
      <HelmetSEO
        lang={GetWindowLanguage()}
        seo_data={story ? story.content.seo : {}}
      />
      <Navbar story_language={GetWindowLanguage()} />
      <PageContentWrapper>
        <div className="homepage">{componentList}</div>
        <div className={styles.footerArea}>
          <button className="btn-scooter-outline" onClick={handleScrollToTop}>
            <FormattedMessage id="page.home.scroll" />
          </button>
        </div>
      </PageContentWrapper>
      <Footer />
    </>
  );
}

export default HomeLayout;
